var map = {
	"./bg-header": 3,
	"./bg-header.jpg": 3,
	"./bg-header.webp": 36,
	"./favicon": 7,
	"./favicon.png": 7,
	"./footer": 8,
	"./footer.svg": 8,
	"./header": 9,
	"./header.svg": 9,
	"./image-wrapper": 10,
	"./image-wrapper.svg": 10,
	"./logo-lucasistencia": 4,
	"./logo-lucasistencia-square": 11,
	"./logo-lucasistencia-square.png": 11,
	"./logo-lucasistencia-white": 12,
	"./logo-lucasistencia-white.png": 12,
	"./logo-lucasistencia.jpg": 37,
	"./logo-lucasistencia.png": 4,
	"./maquinas-de-cafe": 13,
	"./maquinas-de-cafe.jpg": 13,
	"./navPanel": 14,
	"./navPanel.svg": 14,
	"./overlay": 15,
	"./overlay.png": 15,
	"./pic01": 16,
	"./pic01.jpg": 16,
	"./pic02": 17,
	"./pic02.jpg": 17,
	"./pic03": 18,
	"./pic03.jpg": 18,
	"./pic04": 19,
	"./pic04.jpg": 19,
	"./pic05": 20,
	"./pic05.jpg": 20,
	"./pic06": 21,
	"./pic06.jpg": 21,
	"./pic07": 22,
	"./pic07.jpg": 22,
	"./productos": 23,
	"./productos.jpg": 23,
	"./promo": 24,
	"./promo.jpg": 24
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;